///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { repType, status as bidStatus, userRole } from "./types";
import { getBidTags } from "./getBidTags";

const filterBySearchTerm = (bids, searchTerm) => {
  for (let bid of bids) {
    bid.matchesSearch =
      bid.bidName.toLowerCase().includes(searchTerm) ||
      bid.mainSalesRep.fullName.toLowerCase().includes(searchTerm) ||
      bid.modes.some(mode =>
        mode.modeOwner?.fullName.toLowerCase().includes(searchTerm)
      );
  }
};

const filterByUsers = (bids, users, compareModeOwnersOnly) => {
  bids
    .filter(b => b.matchesSearch)
    .forEach(b => {
      b.matchesSearch = b.modes.find(({ modeOwner }) =>
        users.find(
          ({ userId }) =>
            (modeOwner && userId === modeOwner.userId) ||
            (!compareModeOwnersOnly && userId === b.mainSalesRep.userId) ||
            (!compareModeOwnersOnly &&
              b.bidSubscribers.some(s => s.userId === userId))
        )
      )
        ? true
        : false;
    });
};

const filterByBidStatus = (bids, bidsStatus, selectedBidStatus) => {
  selectedBidStatus.find(({ value }) => value === bidsStatus) ||
    bids.forEach(b => (b.matchesSearch = false));
};

const filterByBidTags = (bids, user, selectedTags) => {
  bids
    .filter(b => b.matchesSearch)
    .forEach(b => {
      b.matchesSearch = getBidTags(b, user).find(({ tag }) =>
        selectedTags.find(({ value }) => value === tag)
      )
        ? true
        : false;
    });
};

const filterByAssignments = (bids, user) => {
  bids
    .filter(b => b.matchesSearch)
    .forEach(b => {
      b.matchesSearch = b.truckloadPricingRegionAssignments.some(
        t => t.userId === user.userId
      );
    });
};

const filterByPricingAnalystBids = bids => {
  bids
    .filter(b => b.matchesSearch)
    .forEach(b => {
      b.matchesSearch =
        b.bidOwnerRepType !== repType.sales ||
        Boolean(b.showWhenSelfPricedFeedback);
    });
};

const filterByBidTypes = (bids, selectedBidTypes) => {
  bids
    .filter(b => b.matchesSearch)
    .forEach(b => {
      b.matchesSearch = selectedBidTypes.find(
        ({ value }) => value === b.bidTypeId
      )
        ? true
        : false;
    });
};

export const filterActiveBids = (state, user, cardView) => {
  [
    { bidType: "pendingBids", bidsStatus: bidStatus.pending },
    { bidType: "inProgressBids", bidsStatus: bidStatus.inProgress },
    { bidType: "submittedBids", bidsStatus: bidStatus.submitted },
    { bidType: "feedbackBids", bidsStatus: bidStatus.feedback }
  ].forEach(({ bidType, bidsStatus }) => {
    const filters = state.filters;

    if (!cardView) {
      filters.sortByRfqCloseDate = true;
    }

    const bids = state[bidType];

    filterBySearchTerm(bids, state.filters.searchTerm.toLowerCase());

    if (filters.bidsIAmInTheTeam || filters.bidsIOwn) {
      filterByUsers(bids, [user], !filters.bidsIAmInTheTeam);
    }

    if (filters.selectedUsers) {
      filterByUsers(bids, filters.selectedUsers, false);
    }

    if (!cardView && filters.selectedBidStatus) {
      filterByBidStatus(bids, bidsStatus, filters.selectedBidStatus);
    } else if (cardView) {
      filters.selectedBidStatus = null;
    }

    if (filters.selectedTags) {
      filterByBidTags(bids, user, filters.selectedTags);
    }

    if (
      filters.bidsIHaveAssignments &&
      (user.role === userRole.tlPricingAnalyst ||
        user.role === userRole.assetBasedPricingUser ||
        user.userRoleForManagementUser === userRole.tlPricingAnalyst ||
        user.userRoleForManagementUser === userRole.assetBasedPricingUser)
    ) {
      filterByAssignments(bids, user);
    }

    if (
      user.role === userRole.tlPricingAnalyst ||
      user.role === userRole.assetBasedPricingUser ||
      user.userRoleForManagementUser === userRole.tlPricingAnalyst ||
      user.userRoleForManagementUser === userRole.assetBasedPricingUser
    ) {
      filterByPricingAnalystBids(bids);
    }

    if (filters.selectedBidTypes) {
      filterByBidTypes(bids, filters.selectedBidTypes);
    }
  });
};

export default filterActiveBids;
